import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { endPoints } from '../../../Config';
import { handlePostRequest } from '../../../service/PostTemplate';
import { handlePutRequest } from '../../../service/PutTemplate';
import { handleGetRequest } from '../../../service/GetTemplate';
import { Checkbox } from 'primereact/checkbox';
import { InputTextarea } from 'primereact/inputtextarea';

const AddEditLevel2Question = ({ editable, viewable, onHide, rowRecord, onClose, parentMongoId, parentId }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        message: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('Question is required'),
        text: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('Text is required'),
        refundNamePromptMessage: Yup.string().nullable(),
        refundTicketCreatedMessage: Yup.string().nullable(),
        hasMenu: Yup.boolean()
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            message: '',
            text: '',
            refundNamePromptMessage: '',
            refundTicketCreatedMessage: '',
            parent: '',
            parentId: '',
            hasMenu: false
        },
        onSubmit: async (data) => {
            setLoadingBtn(true);
            const addData = {
                message: data.message,
                text: data.text,
                refundNamePromptMessage: data.refundNamePromptMessage || '',
                refundTicketCreatedMessage: data.refundTicketCreatedMessage || '',
                parent: parentMongoId,
                parentId: parentId,
                hasMenu: data.hasMenu
            };

            if (!editable) {
                const response = await dispatch(handlePostRequest(addData, endPoints.addLevel2Question, true));
                if (response?.status === 201 || response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                const editData = {
                    message: data.message,
                    text: data.text,
                    refundNamePromptMessage: data.refundNamePromptMessage || '',
                    refundTicketCreatedMessage: data.refundTicketCreatedMessage || '',
                    hasMenu: data.hasMenu
                };
                const response = await dispatch(handlePutRequest(editData, endPoints.updateLevel2Question(rowRecord._id), true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getQuestionById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getLevel2QuestionById(rowRecord._id), true);
        if (response) {
            
            formik.setFieldValue('text', response?.data?.text);
            formik.setFieldValue('message', response?.data?.message);
            formik.setFieldValue('refundNamePromptMessage', response?.data?.refundNamePromptMessage || '');
            formik.setFieldValue('refundTicketCreatedMessage', response?.data?.refundTicketCreatedMessage || '');
            formik.setFieldValue('hasMenu', response?.data?.hasMenu);
        }

        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getQuestionById();
        }
    }, [rowRecord]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                {' '}
                <div className="col-12">
                    <div className="field mb-3">
                        <label htmlFor="message">
                            Text <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="message" name="message" placeholder="Enter text" value={formik?.values?.message} maxLength={200} onChange={formik.handleChange} disabled={viewable} className="w-full" />
                        {formik.touched.message && formik.errors.message && <small className="p-error">{formik.errors.message}</small>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="field mb-3">
                        <label htmlFor="text">
                            Level Two Question <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputTextarea id="text" name="text" placeholder="Enter Question" value={formik?.values?.text} maxLength={200} onChange={formik.handleChange} disabled={viewable} className="w-full" />
                        {formik.touched.text && formik.errors.text && <small className="p-error">{formik.errors.text}</small>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="field mb-3">
                        <label htmlFor="refundNamePromptMessage">
                            Refund Follow-up: Ask Name
                        </label>
                        <InputTextarea
                            id="refundNamePromptMessage"
                            name="refundNamePromptMessage"
                            placeholder="Enter follow-up message to request customer's name"
                            value={formik?.values?.refundNamePromptMessage}
                            maxLength={500}
                            onChange={formik.handleChange}
                            disabled={viewable}
                            className="w-full"
                            rows={3}
                        />
                        {formik.touched.refundNamePromptMessage && formik.errors.refundNamePromptMessage && <small className="p-error">{formik.errors.refundNamePromptMessage}</small>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="field mb-3">
                        <label htmlFor="refundTicketCreatedMessage">
                            Refund Follow-up: Ticket Confirmation
                        </label>
                        <InputTextarea
                            id="refundTicketCreatedMessage"
                            name="refundTicketCreatedMessage"
                            placeholder="Enter final confirmation message after ticket creation"
                            value={formik?.values?.refundTicketCreatedMessage}
                            maxLength={500}
                            onChange={formik.handleChange}
                            disabled={viewable}
                            className="w-full"
                            rows={3}
                        />
                        {formik.touched.refundTicketCreatedMessage && formik.errors.refundTicketCreatedMessage && <small className="p-error">{formik.errors.refundTicketCreatedMessage}</small>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="field-checkbox mb-3">
                        <Checkbox inputId="hasMenu" name="hasMenu" checked={formik?.values?.hasMenu} onChange={(e) => formik.setFieldValue('hasMenu', e.checked)} disabled={viewable} />
                        <label htmlFor="hasMenu" className="ml-2">
                            Has Menu
                        </label>
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default AddEditLevel2Question;
